export { default } from './SentToSwitch';
